import React, { useState } from "react";
import "./ResetPassword.scss";
import logo from "../../../assets/images/MainLogo.png";
import TextInput from "../../../components/TextInput/TextInput";
import Buttons from "../../../components/Buttons/Buttons";
import Spinner from "../../../components/Spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { UserPasswordReset } from "../../../utils/apiCalls/auth";
import { useToast } from "../../../utils/ToastContext";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => sessionStorage.getItem("email") || "");
  const [password, setPassword] = useState("");
  const { showToast } = useToast();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleResetPassword = async () => {
    if (isLoading) return;
    setErrors({ email: "", password: "", confirmPassword: "" });
    let isValid = true;
    const newErrors = { email: "", password: "", confirmPassword: "" };

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Enter a valid email";
      isValid = false;
    }
    if (!password || password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
      isValid = false;
    }
    if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(newErrors);
    if (!isValid) return;

    setIsLoading(true);
    const payload = {
      Email: email,
      NewPassword: password,
      ConfirmPassword: confirmPassword,
    };

    try {
      const res = await UserPasswordReset(payload);
      const { statusCode, message, errors: backendErrors } = res;
      if (statusCode === 200) {
        sessionStorage.removeItem("email");
        showToast(message || "Password reset successfully", "success");
        navigate("/");
      } else {
        setIsLoading(false);
        if (backendErrors && typeof backendErrors === "object") {
          const mappedErrors = {};
          if (backendErrors.Email) mappedErrors.email = backendErrors.Email.join(", ");
          if (backendErrors.NewPassword) mappedErrors.password = backendErrors.NewPassword.join(", ");
          if (backendErrors.ConfirmPassword) mappedErrors.confirmPassword = backendErrors.ConfirmPassword.join(", ");
          setErrors((prev) => ({ ...prev, ...mappedErrors }));
        } else {
          showToast(message || "Failed to reset password", "error");
        }
      }
    } catch (error) {
      setIsLoading(false);
      if (error?.errors && typeof error.errors === "object") {
        const mappedErrors = {};
        if (error.errors.Email) mappedErrors.email = error.errors.Email.join(", ");
        if (error.errors.NewPassword) mappedErrors.password = error.errors.NewPassword.join(", ");
        if (error.errors.ConfirmPassword) mappedErrors.confirmPassword = error.errors.ConfirmPassword.join(", ");
        setErrors((prev) => ({ ...prev, ...mappedErrors }));
      } else {
        showToast(error?.message || "An error occurred", "error");
      }
    }
  };

  return (
    <div className="rp">
      {isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <div className="rp_bcg">
        <div className="rp_container">
          <div className="rp_section">
            <div className="rp_section_logo">
              <img src={logo} alt="logo" />
            </div>
            <div className="rp_section_header">
              <h3>Reset Password</h3>
            </div>
            <div className="rp_section_inputs">
              <div className="rp_section_inputs_data">
                <TextInput
                  title={"Email"}
                  type={"email"}
                  placeholder={"example@example.com"}
                  name="email"
                  icon="mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={true}
                  error={!!errors.email}
                  helperText={errors.email}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleResetPassword();
                    }
                  }}
                />
              </div>
              <div className="rp_section_inputs_data">
                <TextInput
                  title={"Password"}
                  type={"password"}
                  placeholder={"********"}
                  name="password"
                  icon="lock"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  error={!!errors.password}
                  helperText={errors.password}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleResetPassword();
                    }
                  }}
                />
              </div>
              <div className="rp_section_inputs_data">
                <TextInput
                  title={"Confirm Password"}
                  type={"password"}
                  placeholder={"********"}
                  name="confirmPassword"
                  icon="lock"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleResetPassword();
                    }
                  }}
                />
              </div>
            </div>
            <div className="rp_section_buttons">
              <Buttons
                text={"Reset Password"}
                variant="primary"
                onClick={handleResetPassword}
                disabled={isLoading}
              />
            </div>
            <div className="rp_section_back">
              <button type="button" className="back-link" onClick={() => navigate("/")}>
                Back to Sign In
              </button>
            </div>
          </div>
        </div>
        <div className="rp_bcglayout"></div>
      </div>
    </div>
  );
};

export default ResetPassword;
